import { useSelector } from 'react-redux';
import { useSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls';
import { selectConversationsForCallerId } from './chatsSlice';
import { ChatType, ConversationState } from './chatsTypes';

export const useChatTypeConversations = (): Record<
  ChatType,
  ConversationState | undefined
> => {
  const callerId = useSelectedCallerID();
  const conversations = useSelector(selectConversationsForCallerId(callerId));

  return {
    agencyShare: conversations.find(c => c.conversationId.startsWith('acs')),
    textFrom911: conversations.find(c => c.conversationId.startsWith('tf911')),
    rcs: conversations.find(c => c.conversationId.startsWith('rcs')),
    conversations: conversations.find(
      c =>
        c.conversationId.startsWith('tcapi') ||
        c.conversationId.startsWith('admin_sms'),
    ),
    collaborator: conversations.find(c =>
      c.conversationId.startsWith('collaborator'),
    ),
  };
};

export const useOpenChatTypes = (): Record<ChatType, boolean> => {
  const conversations = useChatTypeConversations();

  return {
    agencyShare: !conversations.agencyShare?.isCollapsed,
    textFrom911: !conversations.textFrom911?.isCollapsed,
    rcs: !conversations.rcs?.isCollapsed,
    conversations: !conversations.conversations?.isCollapsed,
    collaborator: !conversations.collaborator?.isCollapsed,
  };
};
